var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 256,
    viewBox: "0 0 255 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M227.901 84.3254C229.103 93.379 230.404 102.882 231.863 112.691C234.047 122.207 236.362 132.081 238.704 142.171C241.662 152.006 244.461 162.095 246.945 172.245C249.729 182.061 251.893 191.803 253.228 201.163C254.521 213.949 250.082 233.202 243.631 238.446C238.234 240.229 231.216 240.415 222.668 239.09C213.829 237.152 203.766 234.294 192.682 230.916C181.888 228.124 170.961 225.778 160.168 224.194C149.993 223.995 139.977 224.751 130.191 226.338C120.937 229.263 111.703 232.66 102.492 236.238C93.5481 240.515 84.4268 244.444 75.212 247.693C66.1599 251.018 57.0328 253.272 48.0867 254.245C39.4613 254.875 31.2831 254.035 23.8317 251.618C17.1004 248.681 11.426 244.111 7.08605 237.905C3.7284 231.17 1.82217 222.857 1.46901 213.019C1.95666 202.784 3.70631 191.67 6.41366 179.975C9.34937 168.172 12.8178 155.964 16.5467 143.581C20.0063 131.301 23.4774 118.965 26.8632 106.77C29.7809 94.8488 32.6325 83.1365 35.4645 71.8656C37.9584 61.0348 40.6563 50.7683 43.7281 41.2907C46.765 32.4906 50.4601 24.6499 54.9729 17.998C59.74 12.2044 65.5231 7.69629 72.4125 4.5834C79.6551 2.26927 88.0018 1.2116 97.3967 1.37326C106.964 1.87255 116.926 3.17659 127.006 4.99696C136.901 6.53598 146.693 8.31437 156.154 10.2245C165.17 11.5446 173.721 12.9834 181.611 14.6087C192.281 16.4415 209.01 22.1272 214.946 26.738C219.461 32.1873 224.654 48.4005 225.825 59.1852C226.645 66.6019 227.306 74.9967 227.901 84.3254Z",
    stroke: "#5A42ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "11 9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector16);
export default __webpack_public_path__ + "static/media/Vector-16.69d4a3053485c3c5ad53295371d51a3b.svg";
export { ForwardRef as ReactComponent };